import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";

const categories = [
    { key: "all", label: "TÜMÜ" },
    { key: "askili", label: "ASKILI MERDİVEN" },
    { key: "beton", label: "BETON MERDİVEN" },
    { key: "kapi", label: "AHŞAP KAPI" },
    { key: "kupeste", label: "KÜPEŞTE" },
    { key: "deck", label: "DECK" },
    { key: "pergole", label: "PERGOLE" },
    { key: "dis", label: "DIŞ DOĞRAMA" },
    { key: "dograma", label: "AHŞAP DOĞRAMA" },
];

const galleryImages = [
    { src: "images/galeri/ahsapDograma/galeri-1.jpg", category: "dograma" },
    { src: "images/galeri/ahsapDograma/galeri-2.jpg", category: "dograma" },
    { src: "images/galeri/ahsapDograma/galeri-3.jpg", category: "dograma" },
    { src: "images/galeri/ahsapDograma/galeri-4.jpg", category: "dograma" },
    { src: "images/galeri/ahsapDograma/galeri-5.jpg", category: "dograma" },
    { src: "images/galeri/ahsapDograma/galeri-6.jpg", category: "dograma" },
    { src: "images/galeri/ahsapDograma/galeri-7.jpg", category: "dograma" },

    { src: "images/galeri/ahsapKapi/galeri-1.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-2.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-3.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-4.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-5.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-6.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-7.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-8.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-9.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-10.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-11.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-12.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-13.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-14.jpg", category: "kapi" },
    { src: "images/galeri/ahsapKapi/galeri-15.jpg", category: "kapi" },

    { src: "images/galeri/askiliMerdiven/galeri-1.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-2.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-3.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-4.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-5.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-6.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-7.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-8.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-9.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-10.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-11.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-12.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-13.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-14.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-15.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-16.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-17.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-18.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-19.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-20.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-21.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-22.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-23.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-24.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-25.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-26.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-27.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-28.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-29.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-30.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-31.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-32.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-33.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-34.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-35.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-36.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-37.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-38.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-39.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-40.jpg", category: "askili" },
    { src: "images/galeri/askiliMerdiven/galeri-41.jpg", category: "askili" },

    { src: "images/galeri/betonMerdiven/galeri-1.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-2.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-3.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-4.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-5.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-6.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-7.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-8.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-9.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-10.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-11.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-12.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-13.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-14.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-15.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-16.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-17.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-18.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-19.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-20.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-21.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-22.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-23.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-24.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-25.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-26.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-27.jpg", category: "beton" },
    { src: "images/galeri/betonMerdiven/galeri-28.jpg", category: "beton" },

    { src: "images/galeri/deck/galeri-1.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-2.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-3.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-4.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-5.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-6.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-7.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-8.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-9.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-10.jpg", category: "deck" },
    { src: "images/galeri/deck/galeri-11.jpg", category: "deck" },

    { src: "images/galeri/disDograma/galeri-1.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-2.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-3.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-4.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-5.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-6.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-7.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-8.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-9.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-10.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-11.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-12.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-13.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-14.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-15.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-16.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-17.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-18.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-19.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-20.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-21.jpg", category: "dis" },
    { src: "images/galeri/disDograma/galeri-22.jpg", category: "dis" },

    { src: "images/galeri/kupeste/galeri-1.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-2.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-3.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-4.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-5.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-6.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-7.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-8.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-9.jpg", category: "kupeste" },
    { src: "images/galeri/kupeste/galeri-10.jpg", category: "kupeste" },

    { src: "images/galeri/pergole/galeri-1.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-2.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-3.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-4.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-5.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-6.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-7.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-8.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-9.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-10.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-11.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-12.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-13.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-14.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-15.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-16.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-17.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-18.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-19.jpg", category: "pergole" },
    { src: "images/galeri/pergole/galeri-20.jpg", category: "pergole" },
];

const Galeri = () => {
    const [visibleCount, setVisibleCount] = useState(8);
    const [activeCategory, setActiveCategory] = useState("all");
    const [bigImage, setBigImage] = useState(null);

    const handleCategoryChange = (key) => {
        setActiveCategory(key);
        setVisibleCount(8);
    };

    const filteredImages =
        activeCategory === "all"
            ? galleryImages
            : galleryImages.filter((img) => img.category === activeCategory);

    const loadMoreImages = () => {
        setVisibleCount((prev) => prev + 8);
    };

    return (
        <section className="py-16 lg:py-24 bg-[rgb(20,23,30)]" id="galeri">
            <div className="container flex-col mx-auto px-4">
                {/* Başlık */}
                <div className="text-center mb-10">
                    <h2 className="text-4xl font-extrabold text-gray-200 tracking-wider">
                        Galeri
                    </h2>
                    <div className="w-24 h-1 bg-gray-200 mx-auto mt-4 mb-8" />
                </div>

                {/* Filtre Butonları */}
                <div className="flex flex-wrap justify-center gap-3 mb-10">
                    {categories.map((cat) => (
                        <button
                            key={cat.key}
                            onClick={() => handleCategoryChange(cat.key)}
                            className={`px-5 py-2 text-sm font-semibold rounded-sm border transition-colors duration-200
              ${activeCategory === cat.key
                                    ? "bg-gray-200 text-gray-900 border-gray-200"
                                    : "bg-[rgb(30,34,42)] text-gray-300 border-transparent hover:bg-[rgb(40,45,55)]"
                                }`}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>

                {/* Resimler */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-6">
                    {filteredImages.slice(0, visibleCount).map((image, index) => (
                        <div
                            key={index}
                            className="relative rounded-lg overflow-hidden shadow-md group"
                            onClick={() => setBigImage(image.src)}

                        >
                            <img
                                src={image.src}
                                alt={`Galeri Resmi ${index + 1}`}
                                loading="lazy"
                                className="w-full h-full aspect-[1/1] object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                            />

                            <div className="absolute inset-0 bg-black bg-opacity-0 transition-all duration-300 ease-in-out group-hover:bg-opacity-50" />

                            <div className="absolute inset-0 flex flex-col justify-center items-center opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100">
                                <FaPlus className="text-white text-5xl transform scale-0 group-hover:scale-100 transition-transform duration-300 ease-in-out" />
                                <span className="text-white mt-2 text-sm">{categories.find(cat => cat.key === image.category)?.label}</span>
                            </div>
                        </div>
                    ))}
                </div>
                {bigImage && (
                    <div
                        className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
                        onClick={() => setBigImage(null)}
                    >
                        <img
                            src={bigImage}
                            className="max-w-[90%] max-h-[90%] rounded-lg"
                        />
                    </div>
                )}


                {/* Daha Fazla Göster */}
                {visibleCount < filteredImages.length && (
                    <div className="text-center mt-12">
                        <button
                            onClick={loadMoreImages}
                            className="bg-gray-200 text-gray-800 font-bold py-3 px-8 rounded-lg hover:bg-gray-300 transition-colors duration-300"
                        >
                            Daha Fazla Göster
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Galeri;
